import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getAdjustment(params) {
	return client.get("api/product-stock/data-adjusment", {
		params: params,
	});
}

function getAdjustmentAll(params) {
	return client.get("api/product-stock/data-adjustment-all", {
		params: params,
	});
}

function getDetailSA(params) {
	return client.get("api/product-stock/detail-adjustment", {
		params: {
			code : params
		},
	});
}

function exportAdjustment(params) {
	return client.get("api/product-stock/export-stock-adjustment", {
		params: params,
	});
}

function createAdjustment (params) {
	return client.post("api/product-stock/stock-adjustment", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getAdjustment,
	getAdjustmentAll,
	getDetailSA,
	exportAdjustment,
	createAdjustment,
};